import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Button, EmptySlate, Link } from "@activecollab/components";
import PropTypes from "prop-types";
import Angie from "~/utils/angie";

const NotFoundSlate = ({ header, description, pageName, pageLink }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (Angie.page_reload_needed || Angie.app_reloading) {
    return null;
  }

  return (
    <EmptySlate
      className="tw-my-auto tw-h-full"
      title={header}
      src={`${Angie.assets_url}/system/images/layout/404.png`}
      alt="Not Found"
      style={{ textWrap: "pretty" }}
      description={
        description ||
        t("The {{pageName}} you requested doesn't exist, or you need permission to access it.", {
          pageName,
        })
      }
    >
      <EmptySlate.Footer>
        <Button
          variant="primary"
          onClick={() => navigate("/search")}
        >
          {t("Search Everything")}
        </Button>
        <Link
          className="tw-leading-normal"
          variant="text link-primary"
          to={pageLink}
          as={RouterLink}
        >
          {`${t("Back to")} ${pageName}`}
        </Link>
      </EmptySlate.Footer>
    </EmptySlate>
  );
};

NotFoundSlate.propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  pageName: PropTypes.string.isRequired,
  pageLink: PropTypes.string.isRequired,
};

export default NotFoundSlate;
